module.exports = __webpack_public_path__ + "static/media/welcome.e4bf802a.png";